import VerticalTabbedNavigation from './VerticalTabbedNavigation';

export default VerticalTabbedNavigation;